<!-- <div class="modal-dialog modal-dialog-centered detail-modal"> -->
<div>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update Period Info </h4>
            <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
        </div>
        <div class="modal-body">
            <div class="card" >
                <div class="card-body">
                <form [formGroup]="modelZonePeriodForm" (ngSubmit)="updateZonePeriodDetails()">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="mb-2">
                            <label for="vendor" class="form-label">Vendor <span class="mandatory">*</span></label>
                            <ng-select id="vendor" placeholder="Select" formControlName="ddlVendor" [appendTo]="'body'" [openOnEnter]="false"
                              [items]="vendorList" bindLabel="name" [bindValue]="'id'"
                              class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom" >
                            </ng-select>
                        </div>
                      </div>

                    
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="FromDate" class="form-label"> From Date</label>
                                <input type="date" formControlName="txtFromDate"
                                    class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                    ng-reflect-name="FromDate" >                        
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="ToDate" class="form-label"> To Date</label>
                                <input type="date" formControlName="txtToDate" [min]="currentDate"
                                    class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                    ng-reflect-name="ToDate" >                        
                            </div>
                        </div>
                </div>
                </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="updateZonePeriodDetails()">Save</button> 
        </div>
      </div>
    </div>